import { findUnits } from './helperUtility';
import { findStartDateTime, findFinishDateTime } from './timeUtility';

// eslint-disable-next-line import/prefer-default-export
export const parseCartItems = items => items.reduce((all, item) => {
  const reservationItem = {
    product_title: item.product_title,
    external_id: item.variant_id,
    quantity: findUnits(item),
    status: 'ok',
  };

  if (item.properties) {
    const { Resource, Location } = item.properties;
    if (Resource) reservationItem.resource_name = Resource;
    if (Location) reservationItem.location_name = Location;
  }

  let options = false;
  if (window.bta && window.bta.dateFormat) {
    options = {
      date: { format: window.bta.dateFormat },
      time: true,
    };
  }

  const start = findStartDateTime(item.properties, options);
  if (start) reservationItem.start = start;

  const finish = findFinishDateTime(item.properties, options);
  if (finish) reservationItem.finish = finish;

  all.push(reservationItem);

  return all;
}, []);
